export default {"src":"/pro/_next/static/media/pyth.5f6906bb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};